export const ROLES = {
  USER_ROLE: 'USER',
  ADMIN_ROLE: 'ADMIN',
  SUPER_ADMIN_ROLE: 'SUPER ADMIN',
  SALE_ROLE: 'SALE',
};

export default ROLES;
